import { defineComponent, PropType, ref, watch } from 'vue'
import { CsRadioButton, CsSecondaryButton, MsHeadline } from '@sunrise/components'
import { TimeframeOptions } from '../filter.types'

export default defineComponent({
    name: 'CsTimeframe',
    components: {
        CsRadioButton,
        CsSecondaryButton,
        MsHeadline,
    },
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        modelValue: { type: String as PropType<TimeframeOptions>, default: TimeframeOptions.ANY },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const model = ref(props.modelValue)

        watch(
            () => props.modelValue,
            (modelValue) => {
                model.value = modelValue
            },
        )

        const timeframeOptions = [
            { value: TimeframeOptions.ANY, text: 'Beliebig', key: 1 },
            { value: TimeframeOptions.YESTERDAY, text: 'Gestern', key: 2 },
            { value: TimeframeOptions.LAST_7_DAYS, text: 'Letzte 7 Tage', key: 3 },
            { value: TimeframeOptions.LAST_30_DAYS, text: 'Letzte 30 Tage', key: 4 },
        ]

        function onUpdate(updatedValue: TimeframeOptions) {
            emit('update:modelValue', updatedValue)
        }

        return {
            onUpdate,
            timeframeOptions,
            model,
        }
    },
})
